/**
 * masterViewModell — reine Regeln der Master-/Kunden-Ansicht.
 *
 * Siehe App.js (Sidebar). Fail-closed: NUR `is_master === true` aus einer echten
 * `/api/account/me`-Antwort schaltet die Master-Ansicht frei — nie der lokal
 * gespeicherte `viewMode` allein, und nie ein ausstehender oder gescheiterter Aufruf
 * (dafür steht `isMaster` in App.js auf `null` bzw. wird bei einem Fehler auf
 * `false` gesetzt, niemals auf `true`).
 *
 * Extrahiert (24.08.2026, Aufgabe 4 „Sales-Readiness"), damit diese
 * sicherheitsrelevante Regel unabhängig vom Rendern der Sidebar testbar ist.
 */

export function isAdminView(isMaster, viewMode) {
  return isMaster === true && viewMode === "admin";
}

/**
 * Aus einer `/api/account/me`-Antwort (oder `undefined`/`null` bei einem
 * Fehlerfall) den neuen `isMaster`-Wert ableiten — und ob der lokal gespeicherte
 * `viewMode` auf 'user' zurückgezwungen werden muss, weil der Server keine
 * Master-Rolle bestätigt.
 */
export function deriveMasterState(responseData) {
  const isMaster = responseData?.is_master === true;
  return { isMaster, forceViewToUser: !isMaster };
}
